/**
 * Validates US phone numbers
 * Accepts formats:
 * - (123) 456-7890
 * - 123-456-7890
 * - 123.456.7890
 * - 1234567890
 * - +1 123 456 7890
 */
export function validateUSPhoneNumber(phone: string): boolean {
  // Remove all non-digit characters except +
  const cleaned = phone.replace(/[^\d+]/g, "");

  // Check if it's a valid US phone number (10 digits, optionally with +1 prefix)
  const phoneRegex = /^(\+1)?(\d{10})$/;
  return phoneRegex.test(cleaned);
}

/**
 * Formats a phone number to US format: (XXX) XXX-XXXX
 */
export function formatUSPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, "");

  // Remove leading 1 if present
  const number = cleaned.startsWith("1") ? cleaned.slice(1) : cleaned;

  if (number.length === 10) {
    return `(${number.slice(0, 3)}) ${number.slice(3, 6)}-${number.slice(6)}`;
  }

  return phone; // Return original if not 10 digits
}
